import { atom } from "jotai";

export const notificationsAtom = atom<{ name: string; number: number }[]>([]);
